module.exports = __webpack_public_path__ + "images/sca-veracode-logo-white.png";